import { CustomModal } from '@/components/CustomModal';
import ManageCredits from './ManageCredits';
import { MODAL_IDS } from 'src/enums/EModal';
import { useAppSelector } from '@/store/hooks/useAppSelector';
import { getModalData } from '@/store/modal/selector';

interface ModalData {
	clientId: string;
	clientSubscribedProductId?: string;
	clientSubscriptionStatus?: string;
}

export const ManageCreditsModal = () => {
	const modalData = useAppSelector(getModalData) as ModalData;

	return (
		<CustomModal
			title={`Manage Credits for ${modalData?.clientId}`}
			modalId={MODAL_IDS.RESELLER_MANAGE_CREDITS}
			width={800}
			footer={null}
		>
			<ManageCredits
				clientId={modalData?.clientId}
				clientSubscribedProductId={modalData?.clientSubscribedProductId}
				clientSubscriptionStatus={modalData?.clientSubscriptionStatus}
			/>
		</CustomModal>
	);
};
